import SpriteSymbol from "../../.yarn/cache/svg-baker-runtime-npm-1.4.7-fbb2e3215b-925379c771.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../.yarn/cache/svg-sprite-loader-npm-6.0.11-0d03c2400c-ddbd5ea43d.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark-bold",
  "use": "checkmark-bold-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"checkmark-bold\"><path fill-rule=\"evenodd\" d=\"M76 147.314l-45.656-45.656 11.312-11.312L76 124.69l74.344-74.344 11.312 11.312L76 147.314z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol